<template>
  <a-modal
          title="新增专家信息"
          okText="确认"
          cancelText="取消"
          width="1000px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model ref="ruleForm" :model="formState" :rules="rules" :label-col="{span:8}" :wrapper-col="{span:16}">
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="专家姓名" prop="name">
            <a-input :disabled="this.param.id"  v-model="formState.name"></a-input>
          </a-form-model-item>
        </a-col>
<!--        <a-col span="12">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="性别" prop="sex">
            <a-ext-local-dic-select dic-key="Sex" v-model="formState.sex"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>-->
      </a-row>


      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所属单位" prop="gov">
            <a-input v-model="formState.gov"></a-input>
<!--            <a-ext-gov-select v-model="formState.gov"></a-ext-gov-select>-->

          </a-form-model-item>
        </a-col>
<!--        <a-col span="12">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="现从事专业" prop="zhuanye">
            <a-input v-model="formState.zhuanye"></a-input>
          </a-form-model-item>
        </a-col>-->
      </a-row>


      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="职称" prop="zhicheng">
            <a-ext-local-dic-select dic-key="ZhiCheng" v-model="formState.zhicheng"></a-ext-local-dic-select>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="角色" prop="type">
            <a-input v-model="formState.type"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>


      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="电话" prop="tel">
            <a-input :disabled="this.param.id" v-model="formState.tel"></a-input>
          </a-form-model-item>
        </a-col>
<!--        <a-col span="12">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="邮箱" prop="mail">
            <a-input v-model="formState.mail"></a-input>
          </a-form-model-item>
        </a-col>-->
      </a-row>


      <a-row>
        <a-col span="24">
          <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所在地" prop="address">
            <a-input v-model="formState.address"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

<!--      <a-row>
        <a-col span="24">
          <a-form-model-item  :labelCol="{span:4}" :wrapperCol="{span:20}" label="身份证号码" prop="userCard">
            <a-input  :disabled="this.param.id"  v-model="formState.userCard"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>-->

      <!--<a-row>-->
        <!--<a-col span="24">-->
          <!--<a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="状态" prop="status">-->
            <!--<a-ext-local-dic-select :disabled="param.disabled" dic-key="StdStatus" v-model="formState.status"></a-ext-local-dic-select>-->
          <!--</a-form-model-item>-->
        <!--</a-col>-->
      <!--</a-row>-->

      <a-row>
        <a-col v-if="!this.param.id" span="12">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="账号" prop="account">
            <a-input :disabled="this.param.id" v-model="formState.account"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col v-if="!this.param.id" span="12">
          <a-form-model-item :labelCol="{span:8}" :wrapperCol="{span:16}" label="密码" prop="pwd">
            <a-input v-model="formState.pwd"></a-input>
          </a-form-model-item>
        </a-col>
      </a-row>

    </a-form-model>

  </a-modal>
</template>

<script>
    import axios from '@/api/request';
    import AExtGovSelect from '../../../components/AntDesignExt/All/AExtGovSelect'
    import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'
    import {addorUpdateProfessor as saveApi,getProfessorById as initApi,delProfessorSelected as delPage} from '../../../api/api'
    import {FormRules} from 'antd-form-rules';
    import { notification } from 'ant-design-vue';
    export default {
        name: "FormModel",
        components:{
            AExtLocalDicSelect,AExtGovSelect},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            param:{
                type:Object,
                default: ()=>{
                    return {}
                }
            }
        },
        data() {
            return {
                confirmLoading: false,
                formState: {
                    name:'',
                    sex:'',
                    gov:'',
                    zhuanye:'',
                    zhicheng:'',
                    type:'',
                    tel:'',
                    mail:'',
                    address:'',
                    user_card:'',
                    account: '',
                    pwd: '',
                },
                rules: {
                    name: FormRules.withName('专家姓名').string(1, 200).isRequired().create(),
                    sex: [{ required: true,trigger:'blur', message:'性别不允许为空!' }],
                    gov: FormRules.withName('所属单位').string(1, 200).isRequired().create(),
                    zhuanye: FormRules.withName('现从事专业').string(1, 200).isRequired().create(),
                    zhicheng: [{ required: true,trigger:'blur', message:'职称不允许为空!' }],
                    type: FormRules.withName('职务').string(1, 200).isRequired().create(),
                    tel: FormRules.withName('电话').phone('手机格式不正确').isRequired().create(),
                    mail: FormRules.withName('邮箱').email('邮箱格式不正确').isRequired().create(),
                    address: FormRules.withName('地址').string(1, 200).isRequired().create(),
                    userCard: FormRules.withName('身份证号码').identityCard('身份证号码不正确').isRequired().create(),
                    account: FormRules.withName('账号').string(1, 200,'请填写正确的账号信息').isRequired().create(),
                    pwd:[
                        { required: true, validator: this.checkPassword, trigger: 'blur' }
                    ]
                },

            };
        },
        created(){
            this.initForm();
        },
        methods: {
            checkPassword(rule, value, callback) {
                this.level = []
                if (!value) {
                    return callback('密码不能为空')
                }
                if (value.length < 8) {
                    return callback('密码不少于8位')
                }
                if (value.length > 16) {
                    return callback('密码不大于16位')
                }
                // 校验是数字
                const regex1 = /^\d+$/
                // 校验字母
                const regex2 = /^[A-Za-z]+$/
                // 校验符号
                const regex3 =
                    /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$/
                if (regex1.test(value)) {
                    this.level.push('low')
                } else if (regex2.test(value)) {
                    this.level.push('low')
                } else if (regex3.test(value)) {
                    this.level.push('low')
                } else if (/^[A-Za-z\d]+$/.test(value)) {
                    this.level.push('low')
                    this.level.push('middle')
                } else if (
                    /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\d]+$/.test(
                        value
                    )
                ) {
                    this.level.push('low')
                    this.level.push('middle')
                } else if (
                    /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z]+$/.test(
                        value
                    )
                ) {
                    this.level.push('low')
                    this.level.push('middle')
                } else if (
                    /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z\d]+$/.test(
                        value
                    )
                ) {
                    this.level.push('low')
                    this.level.push('middle')
                    this.level.push('high')
                }
                if(this.level.length<2)
                {
                    return callback('请输入字母、数字或符号的两种')
                }
                return callback()
            },
            initForm(){
                if(this.param.id) {
                    this.confirmLoading = true;
                    initApi(this.param).then((result => {
                        this.formState = result.data.data;
                        this.confirmLoading = false;
                    })).catch(() => {
                        this.confirmLoading = false;
                    });
                }
            },
            handleCancel(e) {
                this.$emit("update:visible",false)
            },
            handleOk(e) {
                this.$refs.ruleForm.validate(valid => {
                    this.formState.regionCode=this.$store.state.user.address.region.code;
                    let user={
                        confirmPassword:this.formState.pwd,
                        idCardNo:this.formState.userCard,
                        name:this.formState.name,
                        password:this.formState.pwd,
                        phone:this.formState.tel,
                        regionCode:this.formState.regionCode,
                        roleId:'1648951568536907777',
                        // roleId:'1560473889248219138',
                        username:this.formState.account
                    }


                    if (valid) {
                        if (!this.param.id) {
                            this.confirmLoading = true;
                            saveApi(this.formState).then((result => {
                                if(result.data.data) {
                                    this.addUser(user).then(res => {
                                        console.log('新建用户',res)
                                        this.enableUser(res.data.data,this.formState.status);
                                        result.data.data.status='启用';
                                        result.data.data.loginId=res.data.data;
                                        if (res.data.msg === 'OK') {
                                            this.confirmLoading = false;
                                            saveApi(result.data.data);
                                            this.$emit("addProfessorClose", true)
                                            this.$emit("update:visible", false)
                                        }
                                        else {
                                            this.$message.error(res.data.msg);
                                            delPage(result.data.data.id).then(() => {
                                            }).catch(err => {
                                            });
                                            this.confirmLoading = false;
                                        }
                                    }).catch(ex=>{
                                        this.$message.error(ex.data.msg);
                                        delPage(result.data.data.id).then(() => {
                                        }).catch(err => {
                                        });
                                        this.confirmLoading = false;
                                    })
                                }
                                else
                                {
                                    this.$message.error(result.data.oper);
                                    this.confirmLoading = false;
                                }
                            })).catch((ex) => {
                                this.$message.error(ex.data.oper);
                                this.confirmLoading = false;
                            });
                        } else {
                            this.confirmLoading = true;
                            saveApi(this.formState).then((result => {
                                this.confirmLoading = false;
                                this.$emit("addProfessorClose", true)
                                this.$emit("update:visible", false)
                            })).catch(() => {
                                this.confirmLoading = false;
                            });
                        }
                    }
                    else
                    {
                        return false;
                    }


                    // if (valid) {
                    //     if (!this.param.id) {
                    //         this.addUser(user).then(res => {
                    //             console.log('新建用户',res)
                    //             this.enableUser(res.data.data,this.formState.status);
                    //             this.formState.status='启用';
                    //             this.formState.loginId=res.data.data;
                    //             if (res.data.msg === 'OK') {
                    //                 this.confirmLoading = true;
                    //                 saveApi(this.formState).then((result => {
                    //                     if(result.data.data) {
                    //                         this.confirmLoading = false;
                    //                         this.$emit("addProfessorClose", true)
                    //                         this.$emit("update:visible", false)
                    //                     }
                    //                     else
                    //                     {
                    //                         this.$message.error(result.data.oper);
                    //                     }
                    //                 })).catch((ex) => {
                    //                     this.$message.error(ex.data.oper);
                    //                     this.confirmLoading = false;
                    //                 });
                    //             }
                    //             else {
                    //                 this.$message.error(res.data.msg);
                    //             }
                    //         }).catch(ex=>{
                    //             this.$message.error(ex.data.msg);
                    //         })
                    //
                    //     } else {
                    //         this.confirmLoading = true;
                    //         saveApi(this.formState).then((result => {
                    //             this.confirmLoading = false;
                    //             this.$emit("addProfessorClose", true)
                    //             this.$emit("update:visible", false)
                    //         })).catch(() => {
                    //             this.confirmLoading = false;
                    //         });
                    //     }
                    // }
                    // else
                    // {
                    //     return false;
                    // }
                });
            },
            addUser(user) {
                const username = user.username.trim();
                return new Promise((resolve, reject) => {
                    axios({
                        url: window.BASE_CONFIG.USER_API+'api/v1/user/saveUser',
                        method: 'post',
                        data: user,
                    })
                        .then((res) => {
                            resolve(res);
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            },
            enableUser(userId,isEnable){
                let stat='enable';
                if(isEnable==='禁用')
                {
                    stat='ban'
                }

                axios({
                    url: window.BASE_CONFIG.USER_API+'api/v1/user/updateBatchById',
                    method: 'post',
                    data: {userIds:[userId],operationType: stat},
                })
                    .then((res) => {
                        console.log('修改状态',res)
                    })
                    .catch((e) => {
                        this.$message.warn('用户添加成功，但启用失败！');
                    });
            }
        },
    }
</script>

<style scoped lang="scss">

  /deep/ .ant-modal-body{
    /*height: 60vh;*/
    /*overflow-y: scroll;*/
  }

</style>
